/** SPEC-AGD-001 — a agenda de contatos.
 *
 * Os tipos descrevem **o que a API devolve**, conferido contra a resposta real.
 *
 * O agrupamento por dia vem pronto do servidor, e não é a tela que o faz: o dia
 * de um instante depende do fuso do tenant, e essa conta não pode existir em
 * dois lugares — o navegador de quem viaja está em outro fuso, e o dia de
 * trabalho continua sendo o da empresa.
 */

import { http } from "@/lib/http";
import type { components } from "@/lib/api-types";

export type Compromisso = components["schemas"]["CompromissoDaAgendaResponse"];

export type DiaDaAgenda = components["schemas"]["DiaDaAgendaResponse"];

export type Agenda = components["schemas"]["AgendaResponse"];

/** Janela obrigatória, e o servidor recusa acima de 62 dias. */
export async function buscarAgenda(desde: Date, ate: Date): Promise<Agenda> {
  const parametros = new URLSearchParams({
    from: desde.toISOString(),
    to: ate.toISOString(),
  });
  return http.get<Agenda>(`/agenda?${parametros.toString()}`);
}
